import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import GlossaryManager from './GlossaryManager';

class GlossaryTermStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.GLOSSARY_GET_TERM:
        GlossaryManager.getTermById(action.id)
        return state;

      case ActionTypes.GLOSSARY_GET_TERM_COMPLETED:
        return action.term;

      default:
        return state;
    }
  }
}

export default new GlossaryTermStore();
